import type { GalleryItem, RoomSnapshot, WishItem } from "../../models/contracts";

export const canShowGalleryItem = (item: GalleryItem, party: RoomSnapshot): boolean =>
  party.tvSettings.enabled && party.tvSettings.galleryEnabled
  && Boolean(item.url) && (party.tvSettings.guestContentPolicy !== "HighlightedOnly" || item.isHighlighted);

export const canShowWish = (wish: WishItem, party: RoomSnapshot): boolean =>
  party.tvSettings.enabled && party.tvSettings.wishWallEnabled
  && party.tvPublicContent.wishVisibility === "Live" && Boolean(wish.text.trim())
  && (party.tvSettings.guestContentPolicy !== "HighlightedOnly" || wish.isHighlighted);

export const canShowPoll = (party: RoomSnapshot): boolean =>
  party.tvSettings.enabled && party.tvSettings.pollsEnabled
  && Boolean(party.activePoll && ["Active", "Completed"].includes(party.activePoll.status));

export const canShowTimeCapsuleStatus = (party: RoomSnapshot): boolean =>
  party.tvSettings.enabled && party.tvSettings.timeCapsuleEnabled
  && Boolean(party.tvPublicContent.timeCapsule);
